import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Signal,
} from '@angular/core';

import {
  CurrencyComponent,
  getColumnKey,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import {
  OrderStatusComponent,
  PublicSubscriptionOrderCollectionFilter,
  PublicSubscriptionOrderCollectionItem,
  RefundedPriceComponent,
} from '@web/shared/module/shop';
import { isNil, isNotNil } from '@web/utils';
import {
  Route,
  RouteParam,
  RouterLinkComponent,
  RouterLinkParams,
} from '@web/common';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'app-public-subscription-order-list-custom-cell-template',
  imports: [
    TableBodyNoReferenceCellComponent,
    OrderStatusComponent,
    RouterLinkComponent,
    Tooltip,
    RefundedPriceComponent,
    CurrencyComponent,
  ],
  templateUrl:
    './public-subscription-order-list-custom-cell-template.component.html',
  styleUrl:
    './public-subscription-order-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSubscriptionOrderListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<PublicSubscriptionOrderCollectionItem, PublicSubscriptionOrderCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<PublicSubscriptionOrderCollectionItem>();

  protected readonly detailsParams = this.detailsParamsSignal();

  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<PublicSubscriptionOrderCollectionItem>;
  protected readonly isNotNil = isNotNil;
  protected readonly Route = Route;

  private detailsParamsSignal(): Signal<RouterLinkParams> {
    return computed(() => ({
      [RouteParam.Number]: this.model().number,
    }));
  }

  protected readonly isNil = isNil;
}
